import PictureComponent from "components/core/picture/picture-component";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import { StyledBadgesGridMobileComponent } from "./badges-grid-mobile-component.scss";

const BadgesGridMobileComponent = ({ badges }) => {
  const itemRenderer = ({ url, name }) => (
    <div className="badge-wrapper">
      <PictureComponent src={url} alt={name} />
    </div>
  );

  const carouselProps = {
    items: badges,
    itemRenderer,
    defaultIndex: Math.floor(badges.length / 2),
    infinite: false,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1
  };

  return (
    <StyledBadgesGridMobileComponent className="badges-grid-mobile-component">
      <Carousel {...carouselProps} />
    </StyledBadgesGridMobileComponent>
  );
};

export default BadgesGridMobileComponent;
